import React from 'react'

export const isPhoneNumber = phone => {
  if (phone.length < 6) {
    return {
      success:false,
      message:"Nomor Telepon tidak valid. Teralu Singkat"
    }
  }
  if (isNaN(phone)){
    return {
      success:false,
      message:"Mohon masukkan nomor telepon asli seperti 62xxx or 08xxx"
    }
  }
  return {
    success:true
  }
};

export const isContainNumber = (field,value) => {
  if (value === 0) {
    return {
      success:false,
      message:`${field} kosong. Mohon diisi terlebih dahulu.`
    }
  }
  return {
    success:true
  }
};

export const isContainText = (field,value) => {
  if (value.length === 0) {
    return {
      success:false,
      message:`${field} kosong. Mohon diisi terlebih dahulu.`
    }
  }
  return {
    success:true
  }
};

export const isCourier = (value) => {
  if (value.length === 0) {
    return {
      success:false,
      message:`Kurir masih kosong. Pilih kurir terlebih dahulu.`
    }
  }
  return {
    success:true
  }
};